import state from '@/stores/buckets/state.js'
import mutations from '@/stores/buckets/mutations.js'
import actions from '@/stores/buckets/actions.js'

export default {
  state,
  mutations,
  actions
}
